import { useEffect, useState } from "react";

const DEFAULT_START = 17 * 60 + 34; // 00:17:34

export function useCountdown(start: number = DEFAULT_START) {
  const [remaining, setRemaining] = useState(start);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? start : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [start]);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  };
}

function pad(n: number) {
  return n.toString().padStart(2, "0");
}
